import {Component, effect, inject, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {Page, PointEmailRequest, ProcessStatus, SrmPointJobDto} from "../../../../../generated-model/model";
import {SrnProcessPointResource} from "../../../../service/SrnProcessPointResource";
import {DecimalPipe} from "@angular/common";
import {notImplementedYet} from "../../../../app.constants";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {filter} from "rxjs/operators";
import {
  ProgressionDialogService
} from "../../../../shared/commons/dialog/progression-dialog/progression-dialog.service";
import {SuccessDialogService} from "../../../../shared/commons/dialog/success-dialog/success-dialog.service";
import {PointJobStatusComponent} from "../../../../shared/components/point-status/point-job-status.component";
import {environment} from "../../../../../environments/environment";
import {
  PointChecklistTableComponent
} from "../../../../shared/components/point-checklist-table/point-checklist-table.component";
import {S3Resource} from "../../../../service/s3-resource.service";

@Component({
  selector: 'app-current-point',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NotFoundComponent,
    SharedCommonModule,
    DecimalPipe,
    PointJobStatusComponent,
    PointChecklistTableComponent
  ],
  templateUrl: './current-point.component.html',
  styleUrl: './current-point.component.scss'
})
export class CurrentPointComponent implements OnInit {
  pageData: Page<any> = {number: 0, size: 10};
  job = signal<SrmPointJobDto>(undefined);
  pointEmailRequestParams: PointEmailRequest = {}
  ProcessStatus = ProcessStatus;
  private readonly service = inject(SrnProcessPointResource);
  protected readonly notImplementedYet = notImplementedYet;
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly progressionDialogService = inject(ProgressionDialogService);
  private readonly successDialogService = inject(SuccessDialogService);
  private readonly s3Resource = inject(S3Resource);

  constructor() {
    effect(() => {
      this.job();
    });
  }

  ngOnInit(): void {
    this.getCurrent();
  }

  getCurrent() {
    this.service.getCurrent()
      .subscribe(value => {
        console.log('job = ', value)
        this.job.set(value);
      });
  }

  callJob() {
    this.confirmDialogService.open({
      isInnerHTML: true,
      content: `<div class="text-danger text-center fw-semibold">ยืนยันการประมวลผล POINT ใหม่?</div>
                <div class="text-center">ระบบจะทำการคำนวนผล POINT ใหม่ ซึ่งจะใช้เวลาไม่ต่ำกว่า 40 นาที</div>`
    })
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังดำเนินการ..."});
          this.service.callJob()
            .subscribe({
              next: e => {
                this.successDialogService.open('กรุณารอจนกว่าระบบจะคำนวนผลลัพธ์เสร็จสิ้น');
                this.getCurrent();
              },
              error: err => {
                this.progressionDialogService.close();
              },
              complete: () => {
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  approve() {
    this.confirmDialogService.open({
      isInnerHTML: true,
      content: `<div class="text-center">กรุณาตรวจสอบข้อมูลให้ครบถ้วน</div>
                <div class="text-danger text-center fw-semibold">เมื่ออนุมัติแล้วจะไม่สามารถแก้ไขข้อมูลได้</div>`
    })
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังดำเนินการ..."});
          this.service.approve()
            .subscribe({
              next: e => {
                this.getCurrent();
                this.successDialogService.open('กรุณารอจนกว่าระบบจะอนุมัติเสร็จสิ้น');
              },
              error: err => {
                this.progressionDialogService.close();
              },
              complete: () => {
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  regenerateFile() {
    this.confirmDialogService.open({
      isInnerHTML: true,
      content: `<div class="text-danger text-center fw-semibold">ยืนยันการสร้างไฟล์ใหม่</div>
                <div class="text-center">ระบบทำการสร้างไฟล์ .mdb ให้อัตโนมัติ</div>`
    })
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังดำเนินการ..."});
          this.service.regenerateFile()
            .subscribe({
              next: e => {
                this.successDialogService.open('กรุณารอจนกว่าระบบจะสร้างไฟล์เสร็จสิ้น');
                this.getCurrent();
              },
              error: err => {
                this.progressionDialogService.close();
              },
              complete: () => {
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  moveResultToHis() {
    this.confirmDialogService.open({
      isInnerHTML: true,
      content: `<div class="text-danger text-center fw-semibold">ยืนยันการย้ายข้อมูล</div>
                <div class="text-center">ระบบทำการยืนยันการย้ายข้อมูล RESULT ไปลงตาราง _HIS</div>`
    })
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังดำเนินการ..."});
          this.service.moveResultToHis()
            .subscribe({
              next: e => {
                this.successDialogService.open('กรุณารอจนกว่าระบบจะย้ายข้อมูลเสร็จสิ้น');
                this.getCurrent();
              },
              error: err => {
                this.progressionDialogService.close();
              },
              complete: () => {
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  sentEmailPoint() {
    this.confirmDialogService.open({
      isInnerHTML: true,
      content: `<div class="text-center fw-semibold">ยืนยันอนุมัติการส่งอีเมล รอบ ${this.job().monthly}</div>`
    })
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังดำเนินการ..."});

          this.pointEmailRequestParams = {
            monthly: this.job().monthly,
            roundText: this.job().roundText,
            // url:`${environment.serverUrl}/#/secure/point/current`
            url: `${environment.serverUrl}/public/api/file-upload/preview?fileName=${this.job().mdbFile?.filename}&contentType=${this.job().mdbFile?.contentType}`
          };

          // เพิ่ม subscribe ตรงนี้
          this.service.sentEmailPoint(this.pointEmailRequestParams)
            .subscribe({
              next: () => {
                this.successDialogService.open('ส่งอีเมลเรียบร้อย');
                this.progressionDialogService.close();
              },
              error: (err) => {
                console.error(err);
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  downloadFileMdb() {
    this.s3Resource.downloadFromFile(this.job().mdbFile);
  }
}
